var _templateObject = _taggedTemplateLiteralLoose(['\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tflex-wrap: wrap;\n\talign-items: ', ';\n\n\t&:after {\n\t\tcontent: "";\n\t\tmax-width: ', ';\n\t\twidth: 100%;\n\n\t\t@media (max-width: 960px) {\n\t\t\tmax-width: ', ';\n\t\t}\n\n\t\t@media (max-width: 680px) {\n\t\t\tmax-width: ', ';\n\t\t}\n\t}\n'], ['\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tflex-wrap: wrap;\n\talign-items: ', ';\n\n\t&:after {\n\t\tcontent: "";\n\t\tmax-width: ', ';\n\t\twidth: 100%;\n\n\t\t@media (max-width: 960px) {\n\t\t\tmax-width: ', ';\n\t\t}\n\n\t\t@media (max-width: 680px) {\n\t\t\tmax-width: ', ';\n\t\t}\n\t}\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import styled from 'styled-components';
import PropTypes from 'prop-types';
var Flex = styled.div(_templateObject, function (_ref) {
  var align = _ref.align;
  return align || "center";
}, function (_ref2) {
  var col = _ref2.col,
      _ref2$gap = _ref2.gap,
      gap = _ref2$gap === undefined ? 1 : _ref2$gap;
  return col && col < 12 ? 100 * col / 12 - gap + '%' : "100%";
}, function (_ref3) {
  var colTablet = _ref3.colTablet,
      _ref3$gabTablet = _ref3.gabTablet,
      gabTablet = _ref3$gabTablet === undefined ? 1 : _ref3$gabTablet;
  return colTablet && colTablet < 12 ? 100 * colTablet / 12 - gabTablet + '%' : "100%";
}, function (_ref4) {
  var colMobile = _ref4.colMobile,
      _ref4$gapMobile = _ref4.gapMobile,
      gapMobile = _ref4$gapMobile === undefined ? 1 : _ref4$gapMobile;
  return colMobile && colMobile < 12 ? 100 * colMobile / 12 - gapMobile + '%' : "100%";
});
Flex.propTypes = {
  align: PropTypes.string,
  col: PropTypes.number,
  gap: PropTypes.number
};
export default Flex;